<template>

  <v-col class="px-0 home">
    <v-row class="mx-0">
        <v-col cols="12" class="py-0 bg-brilliant">
        
          <v-row class="header-section black-transparent-down">

            <v-col cols="12" sm="12" md="12" lg="12" class="mx-auto text-center mb-5">
                <v-img src="../assets/img/monnaie_pirate_logo.png" class="d-none d-sm-inline-flex" width="210"/>
                <v-img src="../assets/img/monnaie_pirate_logo.png" class="d-inline-flex d-sm-none" width="130"/>
                <h1 class="font-main pb-1 pt-0 mb-5 pb-5 yellow-pirate">
                  La monnaie pirate
                </h1>
            </v-col>

            <div class="mx-auto font-large font-oxa pt-0 text-center" style="">
              <TypingTxt :sectionInx="0" :txtInx="1" >
                Prêt à pirater le capitalisme ?
              </TypingTxt>
            </div>

            <v-col cols="12" class="mx-auto mt-5 pt-0 text-center font-oxa">
                            
                <v-btn to="/register" x-large rounded class="yellow-pirate mb-2" 
                      style="background:black; font-size: 1.2em !important; padding:30px; border:3px solid #fbc02d">
                  <v-icon class="mr-1">mdi-account-plus</v-icon>
                  Créer mon compte
                </v-btn>
                
                <br>
                <span class="green--text"><v-icon color="green" small>mdi-check</v-icon> 100% gratuit</span><br>
                <br>Enfin une monnaie virtuelle indépendante,<br>pour construire un nouveau système économique !<br><br>
                <!-- <span class="font-large">1 PRT ~ 100€</span> -->
            </v-col>
          </v-row>

          <v-row class="section-divider"></v-row>
          

          <TypingSection :sectionInx="1">

            <template v-slot:default="slotProps">
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="1" :title="true">
                As-tu déjà rêvé<br>d'un système économique<br>plus juste et équitable ?
              </TypingTxt>
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="2" :desc="true">
                Le capitalisme n'est pas une fatalité !<br>
                Il est possible de créer <span class="yellow-pirate">un autre système</span>.<br>
                Il suffit de créer <span class="yellow-pirate">une autre monnaie</span>,
                basée sur d'autres règles...<br>
              </TypingTxt>
              <br>
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="3" :desc="true">
                <span class="yellow-pirate">La Monnaie Pirate</span> fonctionne selon les principes inverses du capitalisme :
                <br class="d-none d-sm-inline">
                Elle encourage le partage des richesses et non leur accumulation.
                <br class="d-none d-sm-inline">
                Elle favorise les plus pauvres au détriment des plus riches.
              </TypingTxt>
            </template>

          </TypingSection>

          <TypingSection :sectionInx="2">
            <template v-slot:default="slotProps">
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="1" :title="true">
                Une monnaie virtuelle<br>totalement indépendante<br>du système bancaire.
              </TypingTxt>
              
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="2" :desc="true">
                La Monnaie Pirate ne peut être <b class="yellow-pirate" test="plop">ni vendue ni achetée.</b>
              </TypingTxt>
              <br>
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="3" :desc="true">
                <b>Pourquoi ?</b><br>
                Pour qu'aucun milliardaire ne puisse convertir sa fortune en PRT...<br>
              </TypingTxt>
              <br>
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="4" :desc="true">
                Pour avoir de la Monnaie Pirate (PRT)<br>
                il suffit de créer son compte (+10 PRT), puis attendre que le temps passe...<br>
              </TypingTxt>
            </template>
          </TypingSection>

    

          <TypingSection :sectionInx="3">

            <template v-slot:default="slotProps">
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="1" :title="true">
                Un flux de monnaie constant,<br>équitable et automatique.
              </TypingTxt>
              <br>
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="2" :desc="true">
                Le système Pirate créé automatiquement des PRT, tous les jours,
                pour tous les comptes enregistrés.
                <br>
                C'est uniquement de cette façon que sont créés les PRT :
                directement sur vos comptes courants !
              </TypingTxt>
            </template>
          </TypingSection>

          <v-row class="mb-5">
            <v-col cols="12" class="px-3 pb-0 px-md-5 text-center yellow-pirate">
              <!-- <span class="font-large2 font-oxa ">La vie en PRT !</span> -->
              <h2 class="font-large3 mb-10" style="line-height:1em;">
                Un revenu universel quotidien...
              </h2>
            </v-col>
            <v-col cols="12" sm="1" md="1" lg="3" 
                   class="px-3 px-md-5 d-none d-sm-flex">
            </v-col>
            <v-col cols="12" sm="10" md="10" lg="6" class="px-3 mr-auto text-center">

              <img class="mt-5 pb-5 pt-2 d-none d-sm-flex img-wallet" src="../assets/img/homepage/wallet-home2.png" 
                    style="max-width: 1200px;" width="100%"/>

              <img class="d-sm-none px-2 pb-2 pt-2 img-wallet" src="../assets/img/homepage/wallet-home2-xs.png" 
                    style="max-width: 700px;" width="100%"/><br>

              <div class="more-info-on-img d-none d-sm-inline-block">
                <v-btn color="#fbc02d" large class="black--text" to="/about/prt">
                  En savoir plus <v-icon class="mt-1 ml-1" >mdi-chevron-right-circle</v-icon>
                </v-btn>
                <br>
                <span class="mt-3 d-inline-block">Découvrir le fonctionnement mathématique<br>du système monétaire pirate...</span>

                <br><br>
              </div>
            </v-col>
          </v-row>
    

          <TypingSection :sectionInx="4">
            
            <template v-slot:default="slotProps">
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="1" :title="true">
                Combien ça vaut<br>la Monnaie Pirate ?
              </TypingTxt>
              
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="2" :desc="true">
                On dit que <b class="yellow-pirate">1 PRT</b> est équivalent à environ 100€
                <br><br>
                Mais comme on ne peut pas échanger des PRT contre des €uros,<br class="d-none d-sm-inline">
                ce taux de conversion reste purement indicatif.
                <br><br>
                Il sert uniquement à établir un odre de grandeur commun entre les pirates,
                <br class="d-none d-sm-inline">pour fixer des prix cohérents, et donc échanger plus facilement vos PRT entre vous...
              </TypingTxt>
            </template>

          </TypingSection>
    

          <TypingSection :sectionInx="5">
            
            <template v-slot:default="slotProps">
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="1" :title="true">
                Combien on gagne de PRT chaque jour ?
              </TypingTxt>
              
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="2" :desc="true">
                Le système créé <b>0,33 PRT</b> pour toi, chaque jour, soit ~ 33€<br>
                En réalité, le système créé <b>1 PRT</b> par jour et par personne.<br>
                Mais ce PRT est divisé en 3 parts égales, réparties de la façon suivante :
                <br><br>
                1/3 pour la personne<br>
                1/3 pour le Trésor Public<br>
                1/3 pour la Caisse Commune d'Investissement
                <br><br>
                Pourquoi ? <br>
                Grace à ce mécanisme, on créé un système économique où le Trésor Public est alimenté sans aucun impôt ni taxe, 
                et où les investissements privés ne sont plus illimités, mais proportionnels à la quantité d'utilisateurs de la monnaie.
                <!-- <br><br>
                · <u>Trésor Public</u> : caisse pour couvrir les dépenses liés au fonctionnement de la plateforme.<br>
                · <u>Caisse Commune</u> : caisse pour réaliser des emprunts, privés ou professionnels. -->
              </TypingTxt>

              <v-btn color="#fbc02d" large class="black--text mt-10" to="/public-wallets">
                En savoir plus <v-icon class="mt-1 ml-1" >mdi-chevron-right-circle</v-icon>
              </v-btn>

            </template>

          </TypingSection>


          <TypingSection :sectionInx="6">
            
            <template v-slot:default="slotProps">
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="1" :title="true">
                Si on ne peut pas la vendre,<br>comment on utilise sa Monnaie Pirate ?
              </TypingTxt>
              
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="2" :desc="true">
                Tu peux échanger tes PRT contre des biens et des services,<br>
                comme tu le ferais avec n'importe quelle autre monnaie.
                <br><br>
                La différence, c'est qu'il faut trouver les commerçants qui acceptent la Monnaie Pirate.
                <br>
                Car on ne peut pas utiliser ses PRT n'importe où...
                <br><br>
                L'objectif est de convaincre un maximum de petits commerçants et artisans d'accepter le PRT comme moyen de paiement,
                pour étendre au maximum la portée du marché pirate...
                <br><br>
                Plus il y aura de commerçants prêt à accepter la Monnaie Pirate à la place des €uros,<br>
                plus il sera simple de dépenser vos PRT...
              </TypingTxt>
            </template>

          </TypingSection>


          <TypingSection :sectionInx="7">
            
            <template v-slot:default="slotProps">
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="1" :title="true">
               Une monnaie sans impôt, ni taxe !
              </TypingTxt>
              
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="2" :desc="true">
                Les échanges réalisés avec la Monnaie Pirate sont totalement libres !<br>
                L'argent que vous gagnez est à 100% pour vous !<br><br>
                Vous n'avez pas à déclarer vos revenus, ni à payer de cotisation,<br>
                puisque les caisses du Trésor Public des pirates se remplissent uniquement via la création monétaire !
              </TypingTxt>
            </template>

          </TypingSection>



          <v-row class="mb-5">
            <v-col cols="12" class="px-3 px-md-5 text-center">
              <!-- <span class="font-large2 font-oxa ">La vie en PRT !</span> -->
              <h2 class="font-large3 mb-10 yellow-pirate" style="line-height:1em;">
                On va pirater le système<br>sans même l'attaquer...
              </h2>
              <br>
              <!-- <span class="font-oxa yellow-pirate">Utilise tes PRT à la place des €uros, dès que tu en as l'occasion !</span>
              <br> -->
              <span class="font-oxa">
                Pour faire tomber le système, il faut simplement l'abondonner petit à petit,<br>
                et le remplacer par un système <span class="yellow-pirate">plus équitable pour tous...</span>
              </span>
              <br>
            </v-col>

            <v-col cols="12" sm="8" lg="5" class="mx-auto px-3 px-md-5 text-center">

              <a href="https://api.lamonnaiepirate.net/docs/La-Monnaie-Pirate_regles_et_fonctionnement.pdf" target="_blank">
                <v-img class="mt-5 pb-5 pt-2" 
                      style="border-radius: 10px !important; border-bottom: 2px dashed white;" 
                      src="../assets/img/homepage/doc-pdf-preview.png" 
                      width="100%"/>
              </a>
                <v-btn color="blue" large class=" mt-5"  target="_blank"
                       href="https://api.lamonnaiepirate.net/docs/La-Monnaie-Pirate_regles_et_fonctionnement.pdf">
                  <v-icon color="" size="" class="mr-1">mdi-download</v-icon>
                  Télécharger le PDF
                </v-btn>
                <br>
                <small class="d-block pt-2">pour lire la suite du document</small>
            </v-col>
            <v-col cols="12" class="px-3 px-md-5 text-center">
              <h2 class="font- mb-10 mt-10 yellow-pirate font-papyrus">
                En utilisant la Monnaie Pirate au quotidien, tu participes à la création du nouveau système !
              </h2>
            </v-col>
            <v-col cols="12" sm="1" md="1" lg="3" 
                   class="px-3 px-md-5 d-none d-sm-flex">
            </v-col>
            <v-col cols="12" sm="10" md="10" lg="6" class="px-3 mr-auto text-left font-oxa font-mediu">
              <v-row class="mb-5">
                <template v-for="(exemple, n) in rowExemples">
                  <v-col cols="6" sm="6" md="4" lg="4" class="px-2 text-center" v-bind:key="n">

                    <img class="mt-5 mb-1 px-10 d-none d-sm-inline img-exemple" 
                         :src="require('../assets/img/homepage/usage/5/'+(n+1)+'.png')" 
                          style="max-width: 100%;max-height:150px" />

                    <img class="mt-5 mb-1 d-sm-none px-2 pb-2 pt-2 img-exemple" 
                         :src="require('../assets/img/homepage/usage/5/'+(n+1)+'.png')" 
                          style="max-width: 700px;" width="100%"/>
                    <br>
                    <span class="exemple-title yellow-pirate">{{ exemple.title }}</span><br>
                    <b>{{ exemple.price }} PRT {{ exemple.unity }}</b><br>
                    ~ {{ (exemple.price * 100).toFixed(2) }}€

                  </v-col>
                </template>
              </v-row>
            </v-col>
            
          </v-row>
    
    
          <TypingSection :sectionInx="8">

            <template v-slot:default="slotProps">
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="1" :title="true">
                Comment trouver des commerçants qui accèptent la Monnaie Pirate ?
              </TypingTxt>
              
              <TypingTxt :sectionInx="slotProps.sectionInx" :txtInx="2" :desc="true">
                Les commerçants qui souhaitent utiliser la Monnaie Pirate dans le cadre de leur activité 
                sont invités à le faire savoir directemement à leurs clients, de toutes les façons possibles et imaginables.
                <br><br>
                Des visuels sont à leur disposition sur le site, 
                soit pour les imprimer afin de les montrer en magasin, 
                soit pour les utiliser sur les réseaux sociaux.
                <br><br>
                Il n'existe aucun registre public permettant de connaître la liste de tous les professionnels qui utilisent la Monnaie Pirate.
                <br><br>
                Si vos commerçants locaux n'utilisent pas et ne connaissent pas la Monnaie Pirate, profitez-en pour leur en parler !
              </TypingTxt>
              <!-- <v-btn color="blue">Afficher la carte</v-btn> -->
            </template>

          </TypingSection>
    
        <v-row>
          <v-col cols="10" sm="10" md="9" lg="8" id="" class="mx-auto pa-0 img-exemple">
            <!--<MainHomeMap></MainHomeMap>-->
            <!--<DialogEntity></DialogEntity>-->
          </v-col>
        </v-row>


          <v-row class="black-transparent-up" @mouseenter="$root.$emit('startNextTyping', 91)">
    
            <v-col cols="12" sm="11" md="11" lg="9" class="px-2 mx-auto text-center">
                <h2 class=" font-large3 yellow-pirate" style="">
                  La révolution a déjà commencé !
                </h2>
                <br><br><br>
                <v-btn to="/register" large rounded class="yellow-pirate mt-2" 
                      style="background:black; font-size: 1.1em !important; padding:26px; border:3px solid #fbc02d">
                  <v-icon class="mr-1">mdi-account-plus</v-icon>
                  Créer mon compte
                </v-btn>
                <br><br>
                <TypingTxt :sectionInx="9" :txtInx="1" :desc="true" :onetimeonly="true">
                  Tout ce que tu as à faire,<br>
                  c'est t'inscrire gratuitement.
                  <br><br>
                  Tu recevras 10 PRT dès ton inscription,<br>
                  puis entre 0 et 0.33 PRT /jour. 
                  <br><br>
                  Aucun frais caché,<br>aucune carte bleue demandée.
                  <br><br>
                  Tu peux nous faire confiance : on est des pirates !
                </TypingTxt>
                <br><br>
            </v-col>
            
          </v-row>
          
          <v-row class="black-transparent-up d-">
    
            <v-col cols="12" sm="11" md="11" lg="9" class="px-2 mx-auto text-center">
                
                <span class="font-papyrus yellow-pirate">
                  Le capitalisme survivra aussi longtemps qu'on utilisera les monnaies capitalistes.
                  <br>
                  Mais si on arrêter de s'en servir ? Si on les remplaçait par la Monnaie Pirate ?<br>
                  On pourrait tout changer !
                  <br><br><br>
                </span>
            </v-col>
            
          </v-row>
    
    
          <v-row>
            <v-col class="pa-0">
              <Footer v-if="showFooter"/>
            </v-col>
          </v-row>
    
        </v-col>
    </v-row>
  </v-col>

</template>
  
<style>
</style>

<script>

import '@/assets/css/home.css';
import '@/assets/css/mainmap.css';
import '@/assets/css/typing-txt.css';

import Footer from '@/components/main-layout/Footer.vue'
//import DialogEntity from '@/components/map/DialogEntity.vue'
import TypingTxt from '../components/home/TypingTxt.vue';
import TypingSection from '../components/home/TypingSection.vue';
//import MainHomeMap from '../components/map/MainHomeMap.vue';
import router from '../router/router'

export default {
  name: 'home',
  components: {
    Footer, TypingSection, TypingTxt, 
    //MainHomeMap, 
    //DialogEntity
  },
  data: () => ({
    showTopInfoBar: true,
    showFooter: true,
    plans: [],

    rowExemples: [
      { title: "Des fruits et légumes",    price: 0.05,  unity: '/kg' },
      { title: "Un verre en terrasse",     price: 0.07,  unity: '/cocktail' },
      { title: "Se faire un restau",       price: 0.16,  unity: '/personne' },
      { title: "Du pain à la boulangerie", price: 0.01, unity: '/baguette' },
      { title: "Une paire de chaussures",  price: 0.60,  unity: '/paire' },
      { title: "Une coupe de cheveux",     price: 0.40,  unity: '/coupe' },
    ]
  }),
  mounted: async function(){
    if(this.$store.state.auth.isLogin) 
      router.push('/dashboard')

    this.$store.dispatch('app/incStat', '/')
    this.$store.dispatch('app/fetchNbUsersTotal')
    this.$root.$emit("startNextTyping", 1)
    setTimeout(() => {
      this.$root.$emit("startNextTyping", 11)
    }, 3000)
  },
  methods: {
    closeTopInfoBar(){
      this.showTopInfoBar = false
    },
  },
  watch: {
      '$store.state.auth.isLogin': { immediate: true, 
          async handler () {
            //console.log("alo", this.entityParent, this.entityParent == null)
            if(this.$store.state.auth.isLogin) 
              router.push('/dashboard')
          }
      },
  }
}
</script>
